import React from "react";
import "./site-chrome.css";

const navLinks = [
    { label: "Hizmetler", href: "/services/" },
    { label: "Portfolyo", href: "/portfolio/" },
    { label: "Mağaza", href: "/store/" },
    { label: "Eğitim", href: "/education/" },
    { label: "Gizlilik", href: "/privacy" },
];

export default function SiteHeader() {
    return (
        <header className="site-header">
            <a className="site-header__brand" href="/">
                Modelerman
            </a>
            <nav className="site-header__nav" aria-label="Birincil">
                {navLinks.map((link) => (
                    <a key={link.href} href={link.href}>
                        {link.label}
                    </a>
                ))}
            </nav>
            <a className="site-header__cta" href="mailto:studio@modelerman.com">
                Brief gönder
            </a>
        </header>
    );
}
